import React from 'react';
import QaqcPipeRfiFormShared from './QaqcPipeRfiFormShared';

const QaqcPipeRfiFormEdit: React.FC = () => {
  return <QaqcPipeRfiFormShared mode="edit" />;
};

export default QaqcPipeRfiFormEdit;
